"use strict";

var _regeneratorRuntime = require("/workspace/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/workspace/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.default = void 0;

var _addMilliseconds = _interopRequireDefault(require("date-fns/addMilliseconds")),
    _addSeconds = _interopRequireDefault(require("date-fns/addSeconds")),
    _addMinutes = _interopRequireDefault(require("date-fns/addMinutes")),
    _addHours = _interopRequireDefault(require("date-fns/addHours")),
    _addDays = _interopRequireDefault(require("date-fns/addDays")),
    _addWeeks = _interopRequireDefault(require("date-fns/addWeeks")),
    _addMonths = _interopRequireDefault(require("date-fns/addMonths")),
    _addYears = _interopRequireDefault(require("date-fns/addYears")),
    _formatDistanceStrict = _interopRequireDefault(require("date-fns/formatDistanceStrict"));

var BEST_UNIT = "best",
    ADD_UNIT_FN = new Map([["millisecond", _addMilliseconds.default], ["second", _addSeconds.default], ["minute", _addMinutes.default], ["hour", _addHours.default], ["day", _addDays.default], ["week", _addWeeks.default], ["month", _addMonths.default], ["year", _addYears.default]]),
    DISALLOWED_FROM_UNITS = new Set(["millisecond"]);

var _default = function _default() {
  return (
    /*#__PURE__*/

    /**
    * Transform between time units.
    *
    * @param {*} time The base time amount
    * @param {string} [toUnit] The unit to convert the time to (supported units: 'second', 'minute', 'hour', 'day', 'week', 'month', 'year')
    *                          Defaults to using the "best" unit
    * @param {string} [fromUnit='second'] The unit to convert the time from (supported units: 'millisecond', 'second', 'minute', 'hour', 'day', 'week', 'month', 'year')
    * @return {Promise<radspec/evaluator/TypedValue>}
    */
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(time) {
        var toUnit,
            fromUnit,
            addTime,
            zeroDate,
            duration,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                toUnit = _args.length > 1 && _args[1] !== undefined ? _args[1] : BEST_UNIT;
                fromUnit = _args.length > 2 && _args[2] !== undefined ? _args[2] : "second";

                if (!(DISALLOWED_FROM_UNITS.has(fromUnit) || !ADD_UNIT_FN.has(fromUnit))) {
                  _context.next = 4;
                  break;
                }

                throw new Error("@transformTime: Time unit '".concat(fromUnit, "' is not supported as a fromUnit"));

              case 4:
                if (!(toUnit !== BEST_UNIT && !ADD_UNIT_FN.has(toUnit))) {
                  _context.next = 6;
                  break;
                }

                throw new Error("@transformTime: Time unit '".concat(toUnit, "' is not supported as a toUnit"));

              case 6:
                addTime = ADD_UNIT_FN.get(fromUnit), zeroDate = new Date(0), duration = addTime(zeroDate, +time);
                return _context.abrupt("return", {
                  type: "string",
                  value: (0, _formatDistanceStrict.default)(zeroDate, duration, toUnit === BEST_UNIT ? {} : {
                    unit: toUnit
                  })
                });

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()
  );
};

exports.default = _default;